import _asyncToGenerator from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { HttpResponse } from "@aws-sdk/protocol-http";
import { buildQueryString } from "@aws-sdk/querystring-builder";
import { requestTimeout } from "./request-timeout";
export var FetchHttpHandler = /*#__PURE__*/function () {
  function FetchHttpHandler(options) {
    _classCallCheck(this, FetchHttpHandler);
    if (typeof options === "function") {
      this.configProvider = options().then(function (opts) {
        return opts || {};
      });
    } else {
      this.config = options !== null && options !== void 0 ? options : {};
      this.configProvider = Promise.resolve(this.config);
    }
  }
  _createClass(FetchHttpHandler, [{
    key: "destroy",
    value: function destroy() {}
  }, {
    key: "handle",
    value: function () {
      var _handle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        var _ref,
          abortSignal,
          requestTimeoutInMs,
          abortError,
          path,
          queryString,
          auth,
          _request$username,
          _request$password,
          username,
          password,
          port,
          method,
          url,
          body,
          requestOptions,
          fetchRequest,
          raceOfPromises,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, abortSignal = _ref.abortSignal;
                if (this.config) {
                  _context.next = 5;
                  break;
                }
                _context.next = 4;
                return this.configProvider;
              case 4:
                this.config = _context.sent;
              case 5:
                requestTimeoutInMs = this.config.requestTimeout;
                if (!(abortSignal !== null && abortSignal !== void 0 && abortSignal.aborted)) {
                  _context.next = 10;
                  break;
                }
                abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                return _context.abrupt("return", Promise.reject(abortError));
              case 10:
                path = request.path;
                queryString = buildQueryString(request.query || {});
                if (queryString) {
                  path += "?".concat(queryString);
                }
                if (request.fragment) {
                  path += "#".concat(request.fragment);
                }
                auth = "";
                if (request.username != null || request.password != null) {
                  username = (_request$username = request.username) !== null && _request$username !== void 0 ? _request$username : "";
                  password = (_request$password = request.password) !== null && _request$password !== void 0 ? _request$password : "";
                  auth = "".concat(username, ":").concat(password, "@");
                }
                port = request.port, method = request.method;
                url = "".concat(request.protocol, "//").concat(auth).concat(request.hostname).concat(port ? ":".concat(port) : "").concat(path);
                body = method === "GET" || method === "HEAD" ? undefined : request.body;
                requestOptions = {
                  body: body,
                  headers: new Headers(request.headers),
                  method: method
                };
                if (typeof AbortController !== "undefined") {
                  requestOptions["signal"] = abortSignal;
                }
                fetchRequest = new Request(url, requestOptions);
                raceOfPromises = [fetch(fetchRequest).then(function (response) {
                  var fetchHeaders = response.headers;
                  var transformedHeaders = {};
                  var _iterator = _createForOfIteratorHelper(fetchHeaders.entries()),
                    _step;
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var pair = _step.value;
                      transformedHeaders[pair[0]] = pair[1];
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                  var hasReadableStream = response.body != undefined;
                  if (!hasReadableStream) {
                    return response.blob().then(function (body) {
                      return {
                        response: new HttpResponse({
                          headers: transformedHeaders,
                          reason: response.statusText,
                          statusCode: response.status,
                          body: body
                        })
                      };
                    });
                  }
                  return {
                    response: new HttpResponse({
                      headers: transformedHeaders,
                      reason: response.statusText,
                      statusCode: response.status,
                      body: response.body
                    })
                  };
                }), requestTimeout(requestTimeoutInMs)];
                if (abortSignal) {
                  raceOfPromises.push(new Promise(function (resolve, reject) {
                    abortSignal.onabort = function () {
                      var abortError = new Error("Request aborted");
                      abortError.name = "AbortError";
                      reject(abortError);
                    };
                  }));
                }
                return _context.abrupt("return", Promise.race(raceOfPromises));
              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function handle(_x) {
        return _handle.apply(this, arguments);
      }
      return handle;
    }()
  }]);
  return FetchHttpHandler;
}();